import React from 'react'
import { LegalPage } from '@/components/legal/LegalPage'

export const LegalNoticePage: React.FC = () => (
  <LegalPage
    titleKey="legal.legalNotice.title"
    sections={[
      { titleKey: 'legal.legalNotice.title', contentKey: 'legal.legalNotice.intro' },
      { titleKey: 'legal.legalNotice.ipTitle', contentKey: 'legal.legalNotice.ip' },
      { titleKey: 'legal.legalNotice.liabilityTitle', contentKey: 'legal.legalNotice.liability' },
      { titleKey: 'legal.legalNotice.changesTitle', contentKey: 'legal.legalNotice.changes' },
    ]}
  />
)
